import { useState } from "react";
import { ActionItemView } from "./action-item/ActionItemView";
import { DashboardMetricsView } from "./metrics/DashboardMetricsView";
import type { DashboardScope } from "./scope";

export const AdminDashboardView = () => {
	const [scope, setScope] = useState<DashboardScope>("me");

	return (
		<ActionItemView
			scope={scope}
			onScopeChange={setScope}
			topContent={<DashboardMetricsView scope={scope} />}
		/>
	);
};
